import React from 'react';
import { Card } from 'react-bootstrap';
import './ConclusaoPalestra.css';

const ConclusaoPalestra = () => {
  return (
    <Card>
        <div className="conclusao-container">

      <h1 className="conclusao-titulo">Conclusão da Palestra</h1>
      {/* <p className="conclusao-paragrafo">
        Concluímos nossa palestra destacando a importância crucial de uma infraestrutura de rede Wi-Fi robusta e bem configurada. Com o avanço contínuo das tecnologias de rede, como Wi-Fi 6 e o emergente Wi-Fi 7, estamos entrando em uma nova era de conectividade que promete velocidades mais rápidas, maior capacidade e menor latência. Essas melhorias são essenciais para atender às demandas crescentes de dispositivos IoT, aplicações de alta largura de banda, como streaming 8K e realidade virtual, e a necessidade de uma rede segura e confiável.
      </p> */}
      <h2 className="conclusao-subtitulo">Pontos Principais:</h2>
      <h3 className="conclusao-subsubtitulo">Tecnologias Avançadas:</h3>
      <ul className="conclusao-lista">
        <li className="conclusao-item">
          <strong>Wi-Fi 6 e 6E:</strong> Proporcionam melhorias significativas em termos de velocidade e capacidade, utilizando técnicas como MU-MIMO, OFDMA e bandas de 6 GHz para reduzir a interferência e aumentar a eficiência​ (Wi-Fi Alliance)​.
        </li>
        <li className="conclusao-item">
          <strong>Wi-Fi 7:</strong> Espera-se que revolucione ainda mais a conectividade com canais de 320 MHz, Multi-Link Operation (MLO) e 4K QAM, oferecendo velocidades de até 46 Gbps e uma capacidade de rede sem precedentes​ (TechRadar)​​ (9to5Mac)​.
        </li>
      </ul>
      <h3 className="conclusao-subsubtitulo">Importância da Configuração e Manutenção:</h3>
      <ul className="conclusao-lista">
        <li className="conclusao-item">
          Configuração adequada dos roteadores e dispositivos de rede é vital para garantir desempenho ótimo. Ferramentas de análise de rede, como NetSpot e WiFi Analyzer, são essenciais para identificar pontos fracos e otimizar a cobertura.
        </li>
        <li className="conclusao-item">
          Manter o firmware atualizado e implementar protocolos de segurança robustos como WPA3 são medidas essenciais para proteger a rede contra ameaças.
        </li>
      </ul>
      <h3 className="conclusao-subsubtitulo">Desafios e Soluções:</h3>
      <ul className="conclusao-lista">
        <li className="conclusao-item">
          Obstáculos físicos, interferências e alta densidade de dispositivos são desafios comuns que podem ser mitigados com a escolha de equipamentos adequados e planejamento cuidadoso da rede.
        </li>
        <li className="conclusao-item">
          Investimentos em roteadores de alto desempenho e tecnologias avançadas são justificados pela necessidade de suportar aplicações críticas e ambientes densos.
        </li>
      </ul>
      <h3 className="conclusao-subsubtitulo">Qualificação Profissional:</h3>
      <ul className="conclusao-lista">
        <li className="conclusao-item">
          A formação contínua e o uso de ferramentas avançadas são fundamentais para diagnosticar e resolver problemas complexos de rede. Profissionais bem qualificados são essenciais para garantir uma rede eficiente e segura.
        </li>
      </ul>
      <h2 className="conclusao-encerramento">Encerramento</h2>
      <p className="conclusao-paragrafo">
        A adoção dessas tecnologias e práticas avançadas não só melhora a experiência do usuário, mas também prepara a infraestrutura para futuras demandas. Agradeço a todos pela participação e estou à disposição para responder a quaisquer perguntas e discutir mais sobre os desafios e soluções para redes Wi-Fi.
      </p>
      <p className="conclusao-agradecimento">Muito obrigado e espero que esta apresentação tenha sido informativa e útil.</p>
    </div>
      </Card>
  );
};

export default ConclusaoPalestra;
